import { useCallback, useEffect, useState, useRef } from 'react'
import useHistoryUtils from 'hooks/useHistoryUtils'
import type { CmsSubcontentBlockProps } from './types'

const useCmsSubContentBlock = ({ data }: CmsSubcontentBlockProps) => {
  const { subcontentUuid, src, title, previewText } = data
  const [isTitleTwoLines, setIsTitleTwoLines] = useState(false)
  const titleRef = useRef<HTMLHeadingElement>(null)
  const { pushWithRole } = useHistoryUtils()
  const checkTitleHeight = useCallback(() => {
    if (!titleRef.current) return

    const titleHeight = titleRef.current.offsetHeight
    const lineHeight = parseInt(window.getComputedStyle(titleRef.current).lineHeight)

    setIsTitleTwoLines(titleHeight >= lineHeight * 1.4)
  }, [titleRef])

  useEffect(() => {
    if (!titleRef.current) return

    const observer = new ResizeObserver(checkTitleHeight)

    observer.observe(titleRef.current)
  }, [data.title, checkTitleHeight])

  return {
    titleRef,
    isTitleTwoLines,
    setIsTitleTwoLines,
    checkTitleHeight,
    pushWithRole,
    subcontentUuid,
    src,
    title,
    previewText,
  }
}

export default useCmsSubContentBlock
